/* tslint:disable */
/* eslint-disable */
/**
 * Bill Service
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, AxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, RequestArgs, RequiredError } from '../base';
// @ts-ignore
import { AddPaymentToBillRequest } from '../model';
// @ts-ignore
import { AddRefundPreApplyStep } from '../model';
// @ts-ignore
import { AdminPaymentResponse } from '../model';
// @ts-ignore
import { AdminPaymentResponsePaginationResponse } from '../model';
// @ts-ignore
import { BeginPaymentByPaymentLinkRequestDto } from '../model';
// @ts-ignore
import { BeginPaymentErrorResponse } from '../model';
// @ts-ignore
import { BeginPaymentResponse } from '../model';
// @ts-ignore
import { CreateAndSendPaymentLinkToMobileResponseDto } from '../model';
// @ts-ignore
import { GatewayResponse } from '../model';
// @ts-ignore
import { ListPaymentResponse } from '../model';
// @ts-ignore
import { PaymentLinkStatusResponseDto } from '../model';
// @ts-ignore
import { PaymentRequest } from '../model';
// @ts-ignore
import { PreApplyPaymentRefundRequest } from '../model';
// @ts-ignore
import { ResponseDto } from '../model';
// @ts-ignore
import { ValidatePrePayTokenResponse } from '../model';
/**
 * PaymentsApiApiAdminBillsBillCodePaymentsAvailableGatewaysGet - axios parameter creator
 * 
 * @param {string} billCode 
 * @param {*} [options] Override http request option.
 * @throws {RequiredError}
 */
async function PaymentsApiApiAdminBillsBillCodePaymentsAvailableGatewaysGetAxiosParamCreator (billCode: string, options: AxiosRequestConfig = {}, configuration?: Configuration): Promise<RequestArgs> {
    // verify required parameter 'billCode' is not null or undefined
    assertParamExists('apiAdminBillsBillCodePaymentsAvailableGatewaysGet', 'billCode', billCode)
    const localVarPath = `/api/Admin/Bills/{billCode}/Payments/AvailableGateways`
        .replace(`{${"billCode"}}`, encodeURIComponent(String(billCode)));
    // use dummy base URL string because the URL constructor only accepts absolute URLs.
    const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
    let baseOptions;
    if (configuration) {
        baseOptions = configuration.baseOptions;
    }

    const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
    const localVarHeaderParameter = {} as any;
    const localVarQueryParameter = {} as any;

    // authentication bearer required
    // http bearer authentication required
    await setBearerAuthToObject(localVarHeaderParameter, configuration)



    setSearchParams(localVarUrlObj, localVarQueryParameter);
    let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
    localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

    return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
    };
}
/**
 * PaymentsApiApiAdminBillsBillCodePaymentsGatewayIdBeginPaymentValidationAmountPost - axios parameter creator
 * 
 * @param {string} billCode 
 * @param {number} gatewayId 
 * @param {number} amount 
 * @param {*} [options] Override http request option.
 * @throws {RequiredError}
 */
async function PaymentsApiApiAdminBillsBillCodePaymentsGatewayIdBeginPaymentValidationAmountPostAxiosParamCreator (billCode: string, gatewayId: number, amount: number, options: AxiosRequestConfig = {}, configuration?: Configuration): Promise<RequestArgs> {
    // verify required parameter 'billCode' is not null or undefined
    assertParamExists('apiAdminBillsBillCodePaymentsGatewayIdBeginPaymentValidationAmountPost', 'billCode', billCode)
    // verify required parameter 'gatewayId' is not null or undefined
    assertParamExists('apiAdminBillsBillCodePaymentsGatewayIdBeginPaymentValidationAmountPost', 'gatewayId', gatewayId)
    // verify required parameter 'amount' is not null or undefined
    assertParamExists('apiAdminBillsBillCodePaymentsGatewayIdBeginPaymentValidationAmountPost', 'amount', amount)
    const localVarPath = `/api/Admin/Bills/{billCode}/Payments/{gatewayId}/begin-payment-validation/{amount}`
        .replace(`{${"billCode"}}`, encodeURIComponent(String(billCode)))
        .replace(`{${"gatewayId"}}`, encodeURIComponent(String(gatewayId)))
        .replace(`{${"amount"}}`, encodeURIComponent(String(amount)));
    // use dummy base URL string because the URL constructor only accepts absolute URLs.
    const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
    let baseOptions;
    if (configuration) {
        baseOptions = configuration.baseOptions;
    }

    const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
    const localVarHeaderParameter = {} as any;
    const localVarQueryParameter = {} as any;

    // authentication bearer required
    // http bearer authentication required
    await setBearerAuthToObject(localVarHeaderParameter, configuration)



    setSearchParams(localVarUrlObj, localVarQueryParameter);
    let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
    localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

    return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
    };
}
/**
 * PaymentsApiApiAdminBillsBillCodePaymentsGet - axios parameter creator
 * 
 * @param {string} billCode 
 * @param {*} [options] Override http request option.
 * @throws {RequiredError}
 */
async function PaymentsApiApiAdminBillsBillCodePaymentsGetAxiosParamCreator (billCode: string, options: AxiosRequestConfig = {}, configuration?: Configuration): Promise<RequestArgs> {
    // verify required parameter 'billCode' is not null or undefined
    assertParamExists('apiAdminBillsBillCodePaymentsGet', 'billCode', billCode)
    const localVarPath = `/api/Admin/Bills/{billCode}/Payments`
        .replace(`{${"billCode"}}`, encodeURIComponent(String(billCode)));
    // use dummy base URL string because the URL constructor only accepts absolute URLs.
    const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
    let baseOptions;
    if (configuration) {
        baseOptions = configuration.baseOptions;
    }

    const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
    const localVarHeaderParameter = {} as any;
    const localVarQueryParameter = {} as any;

    // authentication bearer required
    // http bearer authentication required
    await setBearerAuthToObject(localVarHeaderParameter, configuration)



    setSearchParams(localVarUrlObj, localVarQueryParameter);
    let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
    localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

    return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
    };
}
/**
 * PaymentsApiApiAdminBillsBillCodePaymentsPaymentIdDelete - axios parameter creator
 * 
 * @param {string} billCode 
 * @param {number} paymentId 
 * @param {*} [options] Override http request option.
 * @throws {RequiredError}
 */
async function PaymentsApiApiAdminBillsBillCodePaymentsPaymentIdDeleteAxiosParamCreator (billCode: string, paymentId: number, options: AxiosRequestConfig = {}, configuration?: Configuration): Promise<RequestArgs> {
    // verify required parameter 'billCode' is not null or undefined
    assertParamExists('apiAdminBillsBillCodePaymentsPaymentIdDelete', 'billCode', billCode)
    // verify required parameter 'paymentId' is not null or undefined
    assertParamExists('apiAdminBillsBillCodePaymentsPaymentIdDelete', 'paymentId', paymentId)
    const localVarPath = `/api/Admin/Bills/{billCode}/Payments/{paymentId}`
        .replace(`{${"billCode"}}`, encodeURIComponent(String(billCode)))
        .replace(`{${"paymentId"}}`, encodeURIComponent(String(paymentId)));
    // use dummy base URL string because the URL constructor only accepts absolute URLs.
    const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
    let baseOptions;
    if (configuration) {
        baseOptions = configuration.baseOptions;
    }

    const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
    const localVarHeaderParameter = {} as any;
    const localVarQueryParameter = {} as any;

    // authentication bearer required
    // http bearer authentication required
    await setBearerAuthToObject(localVarHeaderParameter, configuration)



    setSearchParams(localVarUrlObj, localVarQueryParameter);
    let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
    localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

    return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
    };
}
/**
 * PaymentsApiApiAdminBillsBillCodePaymentsPost - axios parameter creator
 * 
 * @param {string} billCode 
 * @param {PaymentRequest} [paymentRequest] 
 * @param {*} [options] Override http request option.
 * @throws {RequiredError}
 */
async function PaymentsApiApiAdminBillsBillCodePaymentsPostAxiosParamCreator (billCode: string, paymentRequest?: PaymentRequest, options: AxiosRequestConfig = {}, configuration?: Configuration): Promise<RequestArgs> {
    // verify required parameter 'billCode' is not null or undefined
    assertParamExists('apiAdminBillsBillCodePaymentsPost', 'billCode', billCode)
    const localVarPath = `/api/Admin/Bills/{billCode}/Payments`
        .replace(`{${"billCode"}}`, encodeURIComponent(String(billCode)));
    // use dummy base URL string because the URL constructor only accepts absolute URLs.
    const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
    let baseOptions;
    if (configuration) {
        baseOptions = configuration.baseOptions;
    }

    const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
    const localVarHeaderParameter = {} as any;
    const localVarQueryParameter = {} as any;

    // authentication bearer required
    // http bearer authentication required
    await setBearerAuthToObject(localVarHeaderParameter, configuration)



    localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

    setSearchParams(localVarUrlObj, localVarQueryParameter);
    let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
    localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
    localVarRequestOptions.data = serializeDataIfNeeded(paymentRequest, localVarRequestOptions, configuration)

    return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
    };
}
/**
 * PaymentsApiApiAdminBillsBillCodePaymentsPreApplyPost - axios parameter creator
 * 
 * @summary get card info for add payment step
 * @param {string} billCode 
 * @param {PreApplyPaymentRefundRequest} [preApplyPaymentRefundRequest] 
 * @param {*} [options] Override http request option.
 * @throws {RequiredError}
 */
async function PaymentsApiApiAdminBillsBillCodePaymentsPreApplyPostAxiosParamCreator (billCode: string, preApplyPaymentRefundRequest?: PreApplyPaymentRefundRequest, options: AxiosRequestConfig = {}, configuration?: Configuration): Promise<RequestArgs> {
    // verify required parameter 'billCode' is not null or undefined
    assertParamExists('apiAdminBillsBillCodePaymentsPreApplyPost', 'billCode', billCode)
    const localVarPath = `/api/Admin/Bills/{billCode}/Payments/PreApply`
        .replace(`{${"billCode"}}`, encodeURIComponent(String(billCode)));
    // use dummy base URL string because the URL constructor only accepts absolute URLs.
    const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
    let baseOptions;
    if (configuration) {
        baseOptions = configuration.baseOptions;
    }

    const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
    const localVarHeaderParameter = {} as any;
    const localVarQueryParameter = {} as any;

    // authentication bearer required
    // http bearer authentication required
    await setBearerAuthToObject(localVarHeaderParameter, configuration)



    localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

    setSearchParams(localVarUrlObj, localVarQueryParameter);
    let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
    localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
    localVarRequestOptions.data = serializeDataIfNeeded(preApplyPaymentRefundRequest, localVarRequestOptions, configuration)

    return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
    };
}
/**
 * PaymentsApiApiAdminPaymentsGatewaysGet - axios parameter creator
 * 
 * @param {*} [options] Override http request option.
 * @throws {RequiredError}
 */
async function PaymentsApiApiAdminPaymentsGatewaysGetAxiosParamCreator (options: AxiosRequestConfig = {}, configuration?: Configuration): Promise<RequestArgs> {
    const localVarPath = `/api/Admin/Payments/Gateways`;
    // use dummy base URL string because the URL constructor only accepts absolute URLs.
    const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
    let baseOptions;
    if (configuration) {
        baseOptions = configuration.baseOptions;
    }

    const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
    const localVarHeaderParameter = {} as any;
    const localVarQueryParameter = {} as any;

    // authentication bearer required
    // http bearer authentication required
    await setBearerAuthToObject(localVarHeaderParameter, configuration)



    setSearchParams(localVarUrlObj, localVarQueryParameter);
    let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
    localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

    return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
    };
}
/**
 * PaymentsApiApiAdminPaymentsOpenPaymentsGet - axios parameter creator
 * 
 * @param {number} [orderId] 
 * @param {number} [pageNumber] 
 * @param {number} [pageSize] 
 * @param {*} [options] Override http request option.
 * @throws {RequiredError}
 */
async function PaymentsApiApiAdminPaymentsOpenPaymentsGetAxiosParamCreator (orderId?: number, pageNumber?: number, pageSize?: number, options: AxiosRequestConfig = {}, configuration?: Configuration): Promise<RequestArgs> {
    const localVarPath = `/api/Admin/Payments/OpenPayments`;
    // use dummy base URL string because the URL constructor only accepts absolute URLs.
    const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
    let baseOptions;
    if (configuration) {
        baseOptions = configuration.baseOptions;
    }

    const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
    const localVarHeaderParameter = {} as any;
    const localVarQueryParameter = {} as any;

    // authentication bearer required
    // http bearer authentication required
    await setBearerAuthToObject(localVarHeaderParameter, configuration)

    if (orderId !== undefined) {
        localVarQueryParameter['orderId'] = orderId;
    }

    if (pageNumber !== undefined) {
        localVarQueryParameter['pageNumber'] = pageNumber;
    }

    if (pageSize !== undefined) {
        localVarQueryParameter['pageSize'] = pageSize;
    }



    setSearchParams(localVarUrlObj, localVarQueryParameter);
    let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
    localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

    return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
    };
}
/**
 * PaymentsApiApiAdminPaymentsOrderIdGet - axios parameter creator
 * 
 * @param {number} orderId 
 * @param {*} [options] Override http request option.
 * @throws {RequiredError}
 */
async function PaymentsApiApiAdminPaymentsOrderIdGetAxiosParamCreator (orderId: number, options: AxiosRequestConfig = {}, configuration?: Configuration): Promise<RequestArgs> {
    // verify required parameter 'orderId' is not null or undefined
    assertParamExists('apiAdminPaymentsOrderIdGet', 'orderId', orderId)
    const localVarPath = `/api/Admin/Payments/{orderId}`
        .replace(`{${"orderId"}}`, encodeURIComponent(String(orderId)));
    // use dummy base URL string because the URL constructor only accepts absolute URLs.
    const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
    let baseOptions;
    if (configuration) {
        baseOptions = configuration.baseOptions;
    }

    const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
    const localVarHeaderParameter = {} as any;
    const localVarQueryParameter = {} as any;

    // authentication bearer required
    // http bearer authentication required
    await setBearerAuthToObject(localVarHeaderParameter, configuration)



    setSearchParams(localVarUrlObj, localVarQueryParameter);
    let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
    localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

    return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
    };
}
/**
 * PaymentsApiApiAdminPaymentsSetPaymentToBillPost - axios parameter creator
 * 
 * @summary set empty payment to bill
 * @param {AddPaymentToBillRequest} [addPaymentToBillRequest] 
 * @param {*} [options] Override http request option.
 * @throws {RequiredError}
 */
async function PaymentsApiApiAdminPaymentsSetPaymentToBillPostAxiosParamCreator (addPaymentToBillRequest?: AddPaymentToBillRequest, options: AxiosRequestConfig = {}, configuration?: Configuration): Promise<RequestArgs> {
    const localVarPath = `/api/Admin/Payments/SetPaymentToBill`;
    // use dummy base URL string because the URL constructor only accepts absolute URLs.
    const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
    let baseOptions;
    if (configuration) {
        baseOptions = configuration.baseOptions;
    }

    const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
    const localVarHeaderParameter = {} as any;
    const localVarQueryParameter = {} as any;

    // authentication bearer required
    // http bearer authentication required
    await setBearerAuthToObject(localVarHeaderParameter, configuration)



    localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

    setSearchParams(localVarUrlObj, localVarQueryParameter);
    let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
    localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
    localVarRequestOptions.data = serializeDataIfNeeded(addPaymentToBillRequest, localVarRequestOptions, configuration)

    return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
    };
}
/**
 * PaymentsApiApiBillsBeginPaymentByPaymentLinkPost - axios parameter creator
 * 
 * @param {string} [xPlayerID] 
 * @param {BeginPaymentByPaymentLinkRequestDto} [beginPaymentByPaymentLinkRequestDto] 
 * @param {*} [options] Override http request option.
 * @throws {RequiredError}
 */
async function PaymentsApiApiBillsBeginPaymentByPaymentLinkPostAxiosParamCreator (xPlayerID?: string, beginPaymentByPaymentLinkRequestDto?: BeginPaymentByPaymentLinkRequestDto, options: AxiosRequestConfig = {}, configuration?: Configuration): Promise<RequestArgs> {
    const localVarPath = `/api/Bills/BeginPaymentByPaymentLink`;
    // use dummy base URL string because the URL constructor only accepts absolute URLs.
    const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
    let baseOptions;
    if (configuration) {
        baseOptions = configuration.baseOptions;
    }

    const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
    const localVarHeaderParameter = {} as any;
    const localVarQueryParameter = {} as any;

    // authentication bearer required
    // http bearer authentication required
    await setBearerAuthToObject(localVarHeaderParameter, configuration)

    if (xPlayerID != null) {
        localVarHeaderParameter['X-PlayerID'] = String(xPlayerID);
    }



    localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

    setSearchParams(localVarUrlObj, localVarQueryParameter);
    let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
    localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
    localVarRequestOptions.data = serializeDataIfNeeded(beginPaymentByPaymentLinkRequestDto, localVarRequestOptions, configuration)

    return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
    };
}
/**
 * PaymentsApiApiBillsBillCodeBeginPaymentGet - axios parameter creator
 * 
 * @param {string} billCode 
 * @param {boolean} [useCredit] 
 * @param {boolean} [fallback] 
 * @param {boolean} [generatePaymentLink] 
 * @param {string} [captcha] 
 * @param {*} [options] Override http request option.
 * @throws {RequiredError}
 */
async function PaymentsApiApiBillsBillCodeBeginPaymentGetAxiosParamCreator (billCode: string, useCredit?: boolean, fallback?: boolean, generatePaymentLink?: boolean, captcha?: string, options: AxiosRequestConfig = {}, configuration?: Configuration): Promise<RequestArgs> {
    // verify required parameter 'billCode' is not null or undefined
    assertParamExists('apiBillsBillCodeBeginPaymentGet', 'billCode', billCode)
    const localVarPath = `/api/Bills/{billCode}/BeginPayment`
        .replace(`{${"billCode"}}`, encodeURIComponent(String(billCode)));
    // use dummy base URL string because the URL constructor only accepts absolute URLs.
    const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
    let baseOptions;
    if (configuration) {
        baseOptions = configuration.baseOptions;
    }

    const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
    const localVarHeaderParameter = {} as any;
    const localVarQueryParameter = {} as any;

    // authentication bearer required
    // http bearer authentication required
    await setBearerAuthToObject(localVarHeaderParameter, configuration)

    if (useCredit !== undefined) {
        localVarQueryParameter['useCredit'] = useCredit;
    }

    if (fallback !== undefined) {
        localVarQueryParameter['fallback'] = fallback;
    }

    if (generatePaymentLink !== undefined) {
        localVarQueryParameter['generatePaymentLink'] = generatePaymentLink;
    }

    if (captcha !== undefined) {
        localVarQueryParameter['captcha'] = captcha;
    }



    setSearchParams(localVarUrlObj, localVarQueryParameter);
    let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
    localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

    return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
    };
}
/**
 * PaymentsApiApiBillsPaymentLinkStatusTrackingIdGet - axios parameter creator
 * 
 * @param {string} trackingId 
 * @param {string} [xPlayerID] 
 * @param {*} [options] Override http request option.
 * @throws {RequiredError}
 */
async function PaymentsApiApiBillsPaymentLinkStatusTrackingIdGetAxiosParamCreator (trackingId: string, xPlayerID?: string, options: AxiosRequestConfig = {}, configuration?: Configuration): Promise<RequestArgs> {
    // verify required parameter 'trackingId' is not null or undefined
    assertParamExists('apiBillsPaymentLinkStatusTrackingIdGet', 'trackingId', trackingId)
    const localVarPath = `/api/Bills/PaymentLinkStatus/{trackingId}`
        .replace(`{${"trackingId"}}`, encodeURIComponent(String(trackingId)));
    // use dummy base URL string because the URL constructor only accepts absolute URLs.
    const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
    let baseOptions;
    if (configuration) {
        baseOptions = configuration.baseOptions;
    }

    const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
    const localVarHeaderParameter = {} as any;
    const localVarQueryParameter = {} as any;

    // authentication bearer required
    // http bearer authentication required
    await setBearerAuthToObject(localVarHeaderParameter, configuration)

    if (xPlayerID != null) {
        localVarHeaderParameter['X-PlayerID'] = String(xPlayerID);
    }



    setSearchParams(localVarUrlObj, localVarQueryParameter);
    let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
    localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

    return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
    };
}
/**
 * PaymentsApiApiBillsValidatePrePayTokenTokenGet - axios parameter creator
 * 
 * @param {string} token 
 * @param {*} [options] Override http request option.
 * @throws {RequiredError}
 */
async function PaymentsApiApiBillsValidatePrePayTokenTokenGetAxiosParamCreator (token: string, options: AxiosRequestConfig = {}, configuration?: Configuration): Promise<RequestArgs> {
    // verify required parameter 'token' is not null or undefined
    assertParamExists('apiBillsValidatePrePayTokenTokenGet', 'token', token)
    const localVarPath = `/api/Bills/ValidatePrePayToken/{token}`
        .replace(`{${"token"}}`, encodeURIComponent(String(token)));
    // use dummy base URL string because the URL constructor only accepts absolute URLs.
    const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
    let baseOptions;
    if (configuration) {
        baseOptions = configuration.baseOptions;
    }

    const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
    const localVarHeaderParameter = {} as any;
    const localVarQueryParameter = {} as any;

    // authentication bearer required
    // http bearer authentication required
    await setBearerAuthToObject(localVarHeaderParameter, configuration)



    setSearchParams(localVarUrlObj, localVarQueryParameter);
    let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
    localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

    return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
    };
}

/**
 * Request parameters for apiAdminBillsBillCodePaymentsAvailableGatewaysGet operation in PaymentsApi.
 * @export
 * @interface PaymentsApiApiAdminBillsBillCodePaymentsAvailableGatewaysGetRequest
 */
export interface PaymentsApiApiAdminBillsBillCodePaymentsAvailableGatewaysGetRequest {
    /**
     * 
     * @type {string}
     * @memberof PaymentsApiApiAdminBillsBillCodePaymentsAvailableGatewaysGet
     */
    readonly billCode: string
}

/**
 * Request parameters for apiAdminBillsBillCodePaymentsGatewayIdBeginPaymentValidationAmountPost operation in PaymentsApi.
 * @export
 * @interface PaymentsApiApiAdminBillsBillCodePaymentsGatewayIdBeginPaymentValidationAmountPostRequest
 */
export interface PaymentsApiApiAdminBillsBillCodePaymentsGatewayIdBeginPaymentValidationAmountPostRequest {
    /**
     * 
     * @type {string}
     * @memberof PaymentsApiApiAdminBillsBillCodePaymentsGatewayIdBeginPaymentValidationAmountPost
     */
    readonly billCode: string

    /**
     * 
     * @type {number}
     * @memberof PaymentsApiApiAdminBillsBillCodePaymentsGatewayIdBeginPaymentValidationAmountPost
     */
    readonly gatewayId: number

    /**
     * 
     * @type {number}
     * @memberof PaymentsApiApiAdminBillsBillCodePaymentsGatewayIdBeginPaymentValidationAmountPost
     */
    readonly amount: number
}

/**
 * Request parameters for apiAdminBillsBillCodePaymentsGet operation in PaymentsApi.
 * @export
 * @interface PaymentsApiApiAdminBillsBillCodePaymentsGetRequest
 */
export interface PaymentsApiApiAdminBillsBillCodePaymentsGetRequest {
    /**
     * 
     * @type {string}
     * @memberof PaymentsApiApiAdminBillsBillCodePaymentsGet
     */
    readonly billCode: string
}

/**
 * Request parameters for apiAdminBillsBillCodePaymentsPaymentIdDelete operation in PaymentsApi.
 * @export
 * @interface PaymentsApiApiAdminBillsBillCodePaymentsPaymentIdDeleteRequest
 */
export interface PaymentsApiApiAdminBillsBillCodePaymentsPaymentIdDeleteRequest {
    /**
     * 
     * @type {string}
     * @memberof PaymentsApiApiAdminBillsBillCodePaymentsPaymentIdDelete
     */
    readonly billCode: string

    /**
     * 
     * @type {number}
     * @memberof PaymentsApiApiAdminBillsBillCodePaymentsPaymentIdDelete
     */
    readonly paymentId: number
}

/**
 * Request parameters for apiAdminBillsBillCodePaymentsPost operation in PaymentsApi.
 * @export
 * @interface PaymentsApiApiAdminBillsBillCodePaymentsPostRequest
 */
export interface PaymentsApiApiAdminBillsBillCodePaymentsPostRequest {
    /**
     * 
     * @type {string}
     * @memberof PaymentsApiApiAdminBillsBillCodePaymentsPost
     */
    readonly billCode: string

    /**
     * 
     * @type {PaymentRequest}
     * @memberof PaymentsApiApiAdminBillsBillCodePaymentsPost
     */
    readonly paymentRequest?: PaymentRequest
}

/**
 * Request parameters for apiAdminBillsBillCodePaymentsPreApplyPost operation in PaymentsApi.
 * @export
 * @interface PaymentsApiApiAdminBillsBillCodePaymentsPreApplyPostRequest
 */
export interface PaymentsApiApiAdminBillsBillCodePaymentsPreApplyPostRequest {
    /**
     * 
     * @type {string}
     * @memberof PaymentsApiApiAdminBillsBillCodePaymentsPreApplyPost
     */
    readonly billCode: string

    /**
     * 
     * @type {PreApplyPaymentRefundRequest}
     * @memberof PaymentsApiApiAdminBillsBillCodePaymentsPreApplyPost
     */
    readonly preApplyPaymentRefundRequest?: PreApplyPaymentRefundRequest
}

/**
 * Request parameters for apiAdminPaymentsOpenPaymentsGet operation in PaymentsApi.
 * @export
 * @interface PaymentsApiApiAdminPaymentsOpenPaymentsGetRequest
 */
export interface PaymentsApiApiAdminPaymentsOpenPaymentsGetRequest {
    /**
     * 
     * @type {number}
     * @memberof PaymentsApiApiAdminPaymentsOpenPaymentsGet
     */
    readonly orderId?: number

    /**
     * 
     * @type {number}
     * @memberof PaymentsApiApiAdminPaymentsOpenPaymentsGet
     */
    readonly pageNumber?: number

    /**
     * 
     * @type {number}
     * @memberof PaymentsApiApiAdminPaymentsOpenPaymentsGet
     */
    readonly pageSize?: number
}

/**
 * Request parameters for apiAdminPaymentsOrderIdGet operation in PaymentsApi.
 * @export
 * @interface PaymentsApiApiAdminPaymentsOrderIdGetRequest
 */
export interface PaymentsApiApiAdminPaymentsOrderIdGetRequest {
    /**
     * 
     * @type {number}
     * @memberof PaymentsApiApiAdminPaymentsOrderIdGet
     */
    readonly orderId: number
}

/**
 * Request parameters for apiAdminPaymentsSetPaymentToBillPost operation in PaymentsApi.
 * @export
 * @interface PaymentsApiApiAdminPaymentsSetPaymentToBillPostRequest
 */
export interface PaymentsApiApiAdminPaymentsSetPaymentToBillPostRequest {
    /**
     * 
     * @type {AddPaymentToBillRequest}
     * @memberof PaymentsApiApiAdminPaymentsSetPaymentToBillPost
     */
    readonly addPaymentToBillRequest?: AddPaymentToBillRequest
}

/**
 * Request parameters for apiBillsBeginPaymentByPaymentLinkPost operation in PaymentsApi.
 * @export
 * @interface PaymentsApiApiBillsBeginPaymentByPaymentLinkPostRequest
 */
export interface PaymentsApiApiBillsBeginPaymentByPaymentLinkPostRequest {
    /**
     * 
     * @type {string}
     * @memberof PaymentsApiApiBillsBeginPaymentByPaymentLinkPost
     */
    readonly xPlayerID?: string

    /**
     * 
     * @type {BeginPaymentByPaymentLinkRequestDto}
     * @memberof PaymentsApiApiBillsBeginPaymentByPaymentLinkPost
     */
    readonly beginPaymentByPaymentLinkRequestDto?: BeginPaymentByPaymentLinkRequestDto
}

/**
 * Request parameters for apiBillsBillCodeBeginPaymentGet operation in PaymentsApi.
 * @export
 * @interface PaymentsApiApiBillsBillCodeBeginPaymentGetRequest
 */
export interface PaymentsApiApiBillsBillCodeBeginPaymentGetRequest {
    /**
     * 
     * @type {string}
     * @memberof PaymentsApiApiBillsBillCodeBeginPaymentGet
     */
    readonly billCode: string

    /**
     * 
     * @type {boolean}
     * @memberof PaymentsApiApiBillsBillCodeBeginPaymentGet
     */
    readonly useCredit?: boolean

    /**
     * 
     * @type {boolean}
     * @memberof PaymentsApiApiBillsBillCodeBeginPaymentGet
     */
    readonly fallback?: boolean

    /**
     * 
     * @type {boolean}
     * @memberof PaymentsApiApiBillsBillCodeBeginPaymentGet
     */
    readonly generatePaymentLink?: boolean

    /**
     * 
     * @type {string}
     * @memberof PaymentsApiApiBillsBillCodeBeginPaymentGet
     */
    readonly captcha?: string
}

/**
 * Request parameters for apiBillsPaymentLinkStatusTrackingIdGet operation in PaymentsApi.
 * @export
 * @interface PaymentsApiApiBillsPaymentLinkStatusTrackingIdGetRequest
 */
export interface PaymentsApiApiBillsPaymentLinkStatusTrackingIdGetRequest {
    /**
     * 
     * @type {string}
     * @memberof PaymentsApiApiBillsPaymentLinkStatusTrackingIdGet
     */
    readonly trackingId: string

    /**
     * 
     * @type {string}
     * @memberof PaymentsApiApiBillsPaymentLinkStatusTrackingIdGet
     */
    readonly xPlayerID?: string
}

/**
 * Request parameters for apiBillsValidatePrePayTokenTokenGet operation in PaymentsApi.
 * @export
 * @interface PaymentsApiApiBillsValidatePrePayTokenTokenGetRequest
 */
export interface PaymentsApiApiBillsValidatePrePayTokenTokenGetRequest {
    /**
     * 
     * @type {string}
     * @memberof PaymentsApiApiBillsValidatePrePayTokenTokenGet
     */
    readonly token: string
}

/**
* 
* @param {PaymentsApiApiAdminBillsBillCodePaymentsAvailableGatewaysGetRequest} requestParameters Request parameters.
* @param {*} [options] Override http request option.
* @throws {RequiredError}
*/
export async function PaymentsApiApiAdminBillsBillCodePaymentsAvailableGatewaysGet(requestParameters: PaymentsApiApiAdminBillsBillCodePaymentsAvailableGatewaysGetRequest, options?: AxiosRequestConfig, configuration?: Configuration) {
    const localVarAxiosArgs = await PaymentsApiApiAdminBillsBillCodePaymentsAvailableGatewaysGetAxiosParamCreator(requestParameters.billCode, options, configuration);
    const request: () => AxiosPromise<Array<GatewayResponse>> = createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    return request();
}
/**
* 
* @param {PaymentsApiApiAdminBillsBillCodePaymentsGatewayIdBeginPaymentValidationAmountPostRequest} requestParameters Request parameters.
* @param {*} [options] Override http request option.
* @throws {RequiredError}
*/
export async function PaymentsApiApiAdminBillsBillCodePaymentsGatewayIdBeginPaymentValidationAmountPost(requestParameters: PaymentsApiApiAdminBillsBillCodePaymentsGatewayIdBeginPaymentValidationAmountPostRequest, options?: AxiosRequestConfig, configuration?: Configuration) {
    const localVarAxiosArgs = await PaymentsApiApiAdminBillsBillCodePaymentsGatewayIdBeginPaymentValidationAmountPostAxiosParamCreator(requestParameters.billCode, requestParameters.gatewayId, requestParameters.amount, options, configuration);
    const request: () => AxiosPromise<void> = createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    return request();
}
/**
* 
* @param {PaymentsApiApiAdminBillsBillCodePaymentsGetRequest} requestParameters Request parameters.
* @param {*} [options] Override http request option.
* @throws {RequiredError}
*/
export async function PaymentsApiApiAdminBillsBillCodePaymentsGet(requestParameters: PaymentsApiApiAdminBillsBillCodePaymentsGetRequest, options?: AxiosRequestConfig, configuration?: Configuration) {
    const localVarAxiosArgs = await PaymentsApiApiAdminBillsBillCodePaymentsGetAxiosParamCreator(requestParameters.billCode, options, configuration);
    const request: () => AxiosPromise<ListPaymentResponse> = createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    return request();
}
/**
* 
* @param {PaymentsApiApiAdminBillsBillCodePaymentsPaymentIdDeleteRequest} requestParameters Request parameters.
* @param {*} [options] Override http request option.
* @throws {RequiredError}
*/
export async function PaymentsApiApiAdminBillsBillCodePaymentsPaymentIdDelete(requestParameters: PaymentsApiApiAdminBillsBillCodePaymentsPaymentIdDeleteRequest, options?: AxiosRequestConfig, configuration?: Configuration) {
    const localVarAxiosArgs = await PaymentsApiApiAdminBillsBillCodePaymentsPaymentIdDeleteAxiosParamCreator(requestParameters.billCode, requestParameters.paymentId, options, configuration);
    const request: () => AxiosPromise<void> = createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    return request();
}
/**
* 
* @param {PaymentsApiApiAdminBillsBillCodePaymentsPostRequest} requestParameters Request parameters.
* @param {*} [options] Override http request option.
* @throws {RequiredError}
*/
export async function PaymentsApiApiAdminBillsBillCodePaymentsPost(requestParameters: PaymentsApiApiAdminBillsBillCodePaymentsPostRequest, options?: AxiosRequestConfig, configuration?: Configuration) {
    const localVarAxiosArgs = await PaymentsApiApiAdminBillsBillCodePaymentsPostAxiosParamCreator(requestParameters.billCode, requestParameters.paymentRequest, options, configuration);
    const request: () => AxiosPromise<ResponseDto> = createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    return request();
}
/**
* 
* @summary get card info for add payment step
* @param {PaymentsApiApiAdminBillsBillCodePaymentsPreApplyPostRequest} requestParameters Request parameters.
* @param {*} [options] Override http request option.
* @throws {RequiredError}
*/
export async function PaymentsApiApiAdminBillsBillCodePaymentsPreApplyPost(requestParameters: PaymentsApiApiAdminBillsBillCodePaymentsPreApplyPostRequest, options?: AxiosRequestConfig, configuration?: Configuration) {
    const localVarAxiosArgs = await PaymentsApiApiAdminBillsBillCodePaymentsPreApplyPostAxiosParamCreator(requestParameters.billCode, requestParameters.preApplyPaymentRefundRequest, options, configuration);
    const request: () => AxiosPromise<AddRefundPreApplyStep> = createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    return request();
}
/**
* 
* @param {*} [options] Override http request option.
* @throws {RequiredError}
*/
export async function PaymentsApiApiAdminPaymentsGatewaysGet(options?: AxiosRequestConfig, configuration?: Configuration) {
    const localVarAxiosArgs = await PaymentsApiApiAdminPaymentsGatewaysGetAxiosParamCreator(options, configuration);
    const request: () => AxiosPromise<Array<GatewayResponse>> = createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    return request();
}
/**
* 
* @param {PaymentsApiApiAdminPaymentsOpenPaymentsGetRequest} requestParameters Request parameters.
* @param {*} [options] Override http request option.
* @throws {RequiredError}
*/
export async function PaymentsApiApiAdminPaymentsOpenPaymentsGet(requestParameters: PaymentsApiApiAdminPaymentsOpenPaymentsGetRequest = {}, options?: AxiosRequestConfig, configuration?: Configuration) {
    const localVarAxiosArgs = await PaymentsApiApiAdminPaymentsOpenPaymentsGetAxiosParamCreator(requestParameters.orderId, requestParameters.pageNumber, requestParameters.pageSize, options, configuration);
    const request: () => AxiosPromise<AdminPaymentResponsePaginationResponse> = createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    return request();
}
/**
* 
* @param {PaymentsApiApiAdminPaymentsOrderIdGetRequest} requestParameters Request parameters.
* @param {*} [options] Override http request option.
* @throws {RequiredError}
*/
export async function PaymentsApiApiAdminPaymentsOrderIdGet(requestParameters: PaymentsApiApiAdminPaymentsOrderIdGetRequest, options?: AxiosRequestConfig, configuration?: Configuration) {
    const localVarAxiosArgs = await PaymentsApiApiAdminPaymentsOrderIdGetAxiosParamCreator(requestParameters.orderId, options, configuration);
    const request: () => AxiosPromise<AdminPaymentResponse> = createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    return request();
}
/**
* 
* @summary set empty payment to bill
* @param {PaymentsApiApiAdminPaymentsSetPaymentToBillPostRequest} requestParameters Request parameters.
* @param {*} [options] Override http request option.
* @throws {RequiredError}
*/
export async function PaymentsApiApiAdminPaymentsSetPaymentToBillPost(requestParameters: PaymentsApiApiAdminPaymentsSetPaymentToBillPostRequest = {}, options?: AxiosRequestConfig, configuration?: Configuration) {
    const localVarAxiosArgs = await PaymentsApiApiAdminPaymentsSetPaymentToBillPostAxiosParamCreator(requestParameters.addPaymentToBillRequest, options, configuration);
    const request: () => AxiosPromise<void> = createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    return request();
}
/**
* 
* @param {PaymentsApiApiBillsBeginPaymentByPaymentLinkPostRequest} requestParameters Request parameters.
* @param {*} [options] Override http request option.
* @throws {RequiredError}
*/
export async function PaymentsApiApiBillsBeginPaymentByPaymentLinkPost(requestParameters: PaymentsApiApiBillsBeginPaymentByPaymentLinkPostRequest = {}, options?: AxiosRequestConfig, configuration?: Configuration) {
    const localVarAxiosArgs = await PaymentsApiApiBillsBeginPaymentByPaymentLinkPostAxiosParamCreator(requestParameters.xPlayerID, requestParameters.beginPaymentByPaymentLinkRequestDto, options, configuration);
    const request: () => AxiosPromise<CreateAndSendPaymentLinkToMobileResponseDto> = createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    return request();
}
/**
* 
* @param {PaymentsApiApiBillsBillCodeBeginPaymentGetRequest} requestParameters Request parameters.
* @param {*} [options] Override http request option.
* @throws {RequiredError}
*/
export async function PaymentsApiApiBillsBillCodeBeginPaymentGet(requestParameters: PaymentsApiApiBillsBillCodeBeginPaymentGetRequest, options?: AxiosRequestConfig, configuration?: Configuration) {
    const localVarAxiosArgs = await PaymentsApiApiBillsBillCodeBeginPaymentGetAxiosParamCreator(requestParameters.billCode, requestParameters.useCredit, requestParameters.fallback, requestParameters.generatePaymentLink, requestParameters.captcha, options, configuration);
    const request: () => AxiosPromise<BeginPaymentResponse> = createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    return request();
}
/**
* 
* @param {PaymentsApiApiBillsPaymentLinkStatusTrackingIdGetRequest} requestParameters Request parameters.
* @param {*} [options] Override http request option.
* @throws {RequiredError}
*/
export async function PaymentsApiApiBillsPaymentLinkStatusTrackingIdGet(requestParameters: PaymentsApiApiBillsPaymentLinkStatusTrackingIdGetRequest, options?: AxiosRequestConfig, configuration?: Configuration) {
    const localVarAxiosArgs = await PaymentsApiApiBillsPaymentLinkStatusTrackingIdGetAxiosParamCreator(requestParameters.trackingId, requestParameters.xPlayerID, options, configuration);
    const request: () => AxiosPromise<PaymentLinkStatusResponseDto> = createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    return request();
}
/**
* 
* @param {PaymentsApiApiBillsValidatePrePayTokenTokenGetRequest} requestParameters Request parameters.
* @param {*} [options] Override http request option.
* @throws {RequiredError}
*/
export async function PaymentsApiApiBillsValidatePrePayTokenTokenGet(requestParameters: PaymentsApiApiBillsValidatePrePayTokenTokenGetRequest, options?: AxiosRequestConfig, configuration?: Configuration) {
    const localVarAxiosArgs = await PaymentsApiApiBillsValidatePrePayTokenTokenGetAxiosParamCreator(requestParameters.token, options, configuration);
    const request: () => AxiosPromise<ValidatePrePayTokenResponse> = createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    return request();
}
